/**
 * Logo Component
 * Blue square container with centered white letter 'O' (Orion branding).
 */

function Logo({ size = 40, className = '' }) {
  return (
    <div
      className={`flex items-center justify-center bg-blue-600 rounded flex-shrink-0 ${className}`}
      style={{ width: size, height: size }}
      aria-label="Orion logo"
    >
      <span
        className="text-white font-bold font-sans select-none"
        style={{
          fontSize: size * 0.6,
          lineHeight: 1,
          color: 'white',
        }}
      >
        O
      </span>
    </div>
  )
}

export default Logo
